import { IContext } from "@src/context";

export function getDate(
  context: IContext,
  date: Date
): {
  year: number;
  month: string;
  day: string;
} {
  const { intl } = context;
  /*
    ja: { year: 2021, month: "1月", day: "1日" }
    en: { year: 2021, month: "Jan", day: "01" }
    pt: { year: 2021, month: "01", day: "01" }
    vi: { year: 2021, month: "01", day: "01" }
    zh: { year: 2021, month: "1月", day: "1日" }
  */
  return {
    year: date.getFullYear(),
    month:
      context.locale === "en"
        ? intl.formatDate(date, { month: "short" })
        : intl.formatDate(date, { month: "2-digit" }),
    day: intl.formatDate(date, { day: "2-digit" }),
  };
}
